import { buildTypedMap } from '../types/TypedMap';
import { FETCH_MULTI_CURRENCY_STARTED, FETCH_MULTI_CURRENCY_SUCCEEDED } from '../actions/ActionTypes';
import { requestStatuses } from '../constants/RequestStatusTypes';
const initialState = buildTypedMap({
  currencyInfo: null,
  currencyInfoStatus: requestStatuses.UNINITIALIZED
});
const multiCurrency = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MULTI_CURRENCY_STARTED:
      return state.merge({
        currencyInfoStatus: requestStatuses.STARTED
      });
    case FETCH_MULTI_CURRENCY_SUCCEEDED:
      {
        const {
          payload
        } = action;
        return state.merge({
          currencyInfoStatus: requestStatuses.SUCCEEDED,
          currencyInfo: payload
        });
      }
    default:
      return state;
  }
};
export default multiCurrency;